/* 🤖 this file was generated by svg-to-ts */
export const iconChevronDown: {
  name: 'chevron_down';
  data: string;
} = {
  name: 'chevron_down',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 9"><path d="M8 8.42c-.641 0-1.244-.25-1.697-.703l-6.01-6.01A.999.999 0 111.707.293l6.01 6.01c.204.203.362.203.565 0l6.011-6.01a.999.999 0 111.414 1.414l-6.01 6.01A2.385 2.385 0 018 8.42"/></svg>`,
};
